import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { MaterialModule } from '../../../core/shared/material.module';

@Component({
  selector: 'app-menu-dropdown',
  standalone: true,
  imports: [CommonModule, NzMenuModule, MaterialModule],
  templateUrl: './menu-dropdown.component.html',
  styleUrl: './menu-dropdown.component.scss'
})
export class MenuDropdownComponent {
  
  @Input()
  placeholderText = '';

  @Input()
  customStyle: any = {};

  @Input()
  data: any = [];

  @Input()
  selectedValue: any;

  @Output() onSelect = new EventEmitter();

  label: any = 'Select';
  isOpen = false;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('app-menu-dropdown')) {
      this.isOpen = false;
    }
  }

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  ngOnInit() {
    if(!this.selectedValue && this.placeholderText) {
      this.label = this.placeholderText;
    }
    this.setPlaceholderTxt(this.selectedValue);
  }

  setValue(option: any) {
    this.selectedValue = option.value || option.id;
    this.setPlaceholderTxt(option.value || option.id);
    this.onSelect.emit(option);
    this.isOpen = false;
  }

  setPlaceholderTxt(val: string) {
    if(!this.selectedValue) {
      return;
    }
    this.setLabelRecursively(this.data, val);
  }

  setLabelRecursively(arr: any, targetVal: string) {
    arr.forEach((ele: any) => {
      if(ele?.value === targetVal || ele?.id === targetVal) {
        this.label = ele.label;
      }
      if(ele.options?.length) {
        this.setLabelRecursively(ele.options, targetVal);
      }
    });
  }
}
